import { Component, Input, OnInit, inject } from "@angular/core";
import { AlertController, ModalController, IonicModule } from "@ionic/angular";
import { Assessment, AssessmentRequestStatus, AssessmentResponse, AssessmentResultData, AssessmentResults, AssessmentType, Person, AllTestResults, TestResults, SpiritualGiftsService } from "../services/spiritual-gifts/spiritual-gifts.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { addIcons } from 'ionicons';
import { reloadOutline, sync } from 'ionicons/icons';
import { AssessmentsService } from "../services/rock/Assessments/Assessments.service";
import { PeopleService } from "../services/rock/People/People.service";
import { ResultsModalComponent } from "../results-modal/results-modal.component";
import { environment } from "src/environments/environment.prod";

import rockQuestions from '../services/spiritual-gifts/assets/rock_questions.json';
import rockCategories from '../services/spiritual-gifts/assets/rock_categories.json';

import questions2024 from '../services/spiritual-gifts/assets/2024_questions.json';
import categories2024 from '../services/spiritual-gifts/assets/2024_categories.json';

import questions2022 from '../services/spiritual-gifts/assets/2022_questions.json';
import categories2022 from '../services/spiritual-gifts/assets/2022_categories.json';

@Component({
		selector: 'app-take-test',
		templateUrl: './take-test.component.html',
		styleUrl: './take-test.component.scss',
		standalone: true,
		imports: [IonicModule, FormsModule, ReactiveFormsModule]
})
export class TakeTestComponent implements OnInit {

		private spiritualGiftsService = inject(SpiritualGiftsService);
		private assessmentService = inject(AssessmentsService);
		private peopleService = inject(PeopleService);
		private alertCtrl = inject(AlertController);
		private modalCtrl = inject(ModalController);

		_assessmentResponses: AssessmentResponse[] = [];
		CurrentQuestions: AssessmentResponse[] = [];
		PercentComplete: number = 0;
		QuestionCount: number = 1;
		StartDateTime: Date;
		lResult: string = '';

		pnlAssessment: boolean = true;
		pnlResult: boolean
		pnlQuestion: boolean;
		pnlInstructions: boolean = true;

		rQuestions_ItemDataBound: any[] = [];
		PercentCompleteString: string = '0%';
		
		hfAssessmentId: number; // The assessment Id
		hfPageNo: number = 1; // The page number

		responseOptions = [
				{value: "4", label: 'Strongly Agree'},
				{value: "3", label: 'Agree'},
				{value: "2", label: 'Somewhat Agree'},
				{value: "1", label: 'Neutral'},
				{value: "0", label: 'Disagree'},
		];

	
		@Input() testTypeOptions = {
			type: 'lbc_2022',
			randomizeQuestions: true,
			allowAutomate: false
		};
		@Input() _targetPerson: Person;

		constructor() {
			addIcons({ reloadOutline, sync });
		}

		ngOnInit(): void {
			this.changeTest();
		}

		closeModal(data?: any, role: string = 'cancel') {
			this.modalCtrl.dismiss(data, role, 'takeTest');
		}

		changeTest() {
			let questions: any;
			let categories: any;

			switch (this.testTypeOptions.type) {
				case 'lbc_2024':
					questions = questions2024;
					categories = categories2024;
					break;
				case 'lbc_2022':
					questions = questions2022;
					categories = categories2022;
					break;
				case 'rock_default':
				default:
					questions = rockQuestions;
					categories = rockCategories;
					break;
			}

			this.spiritualGiftsService.changeTest(questions, categories);

			this.resetTest();
		}

		logValue(event: any, assessmentItem: AssessmentResponse) {
			assessmentItem.Response = +event?.detail?.value;
			this.calculateProgress();
		}

		isSelected(value, assessmentItem: AssessmentResponse) {
			return assessmentItem.ResponseString === value ? 'ion-color-primary-gradient' : '';
		}

		calculateProgress() {
				const allQuestions = [...this._assessmentResponses];
				const completedQuestions = allQuestions.filter(q => q.Response > -1).length;
				const percentage = (completedQuestions / this._assessmentResponses.length);
				this.PercentComplete = percentage;
				this.PercentCompleteString = `${(Math.round(percentage * 100))}%`;
		}

		startTestTime() {
			this.StartDateTime = new Date(Date.now());
		}

		async btnRetakeTest_Click() {
				this.hfAssessmentId = 0;
		}

		async restartTest() {
				const modal = await this.alertCtrl.create({
						header: 'Restart Test?',
						message: 'Are you sure you want to restart? You will lose all your responses.',
						mode: 'ios',
						buttons: [
								{
										text: 'OK',
										role: 'submit',
								},
								{text: 'Cancel', role: 'cancel'}
						]
				});
				await modal.present();
				await modal.onDidDismiss().then(res => {
						if (res.role === 'submit') {
								this.resetTest();
						}
				});
		}

		resetTest(resetTime: boolean = true) {
				this.hfPageNo = 1;
				this.hfAssessmentId = 0;
				this.pnlInstructions = true;
				this._assessmentResponses = [];
				this.PercentComplete = 0;
				this.PercentCompleteString = '0%';
				if (resetTime) {
					this.startTestTime();
				}
				this.ShowQuestions();
		}

		questionsAnswered():boolean  {
				const allQuestionsAnswered = this.CurrentQuestions.every(a => a.Response !== undefined && a.Response > -1);
				return allQuestionsAnswered;
		}

		isEnd() {
				return (this._assessmentResponses.length) === ((this.hfPageNo) * this.QuestionCount);
		}

		getNextLabel() {
				return this.isEnd() ? 'Submit' : 'Next';
		}

		automateTest() {
				// Reset the test
				this.resetTest(false);

				setTimeout(async () => {
						for (const q of this._assessmentResponses) {
								const number = Math.floor(Math.random() * 5);
								this.CurrentQuestions[0].Response = number;
								this.CurrentQuestions[0].ResponseString = number.toString();
								this.calculateProgress();
								await new Promise(resolve => setTimeout(resolve, 5));
								this.btnNext_Click();
						}
				}, 200);
		}

		btnNext_Click() {
				if (this.isEnd()) {
						this.SaveAssessmentResults();
				} else {
						const pageNumber = this.hfPageNo + 1;
						const totalQuestion = pageNumber * this.QuestionCount;
						if (this._assessmentResponses.length > (totalQuestion - 1) && this.questionsAnswered()) {
								this.hfPageNo = pageNumber;
								this.GetCurrentQuestions();
						}
				}
		}

		async SaveAssessmentResults() {
			const resultData = new Map();
			this._assessmentResponses.map(a => resultData.set(a.Code, a.Response));
			const result: AssessmentResults = this.spiritualGiftsService.GetResult(resultData);

			// Save the attribute values to the person record
			// this.spiritualGiftsService.SaveAssessmentResults(this._targetPerson, result);

			let assessment: Assessment = null;

			if (this.hfAssessmentId !== 0) {
					// Need API to retrieve the assessment based on its id
					assessment = await this.assessmentService.GetAssessmentsByid(this.hfAssessmentId);
			}
			if (assessment === null) {
					const assessmentType = new AssessmentType();
					assessment = new Assessment();
					assessment.AssessmentTypeId = assessmentType.Id;
					assessment.PersonAliasId = this._targetPerson.PrimaryAliasId;
			}
			assessment.Status = AssessmentRequestStatus.Complete;
			assessment.RequestedDateTime = this.StartDateTime.toString();
			assessment.CompletedDateTime = new Date(Date.now()).toString();

			const elapsedMs = new Date().getTime() - this.StartDateTime.getTime();

			const totalSeconds = Math.floor(elapsedMs / 1000);
			const minutes = Math.floor(totalSeconds / 60);
			const seconds = totalSeconds % 60;

			const assessmentResultData = new AssessmentResultData(resultData, result.SpiritualGiftScores, totalSeconds);
			assessment.AssessmentResultData = JSON.stringify(assessmentResultData);

			// Save changes here
			// Save the assessment
			// this.assessmentService.PostAssessments(assessment);

			// Show or navigate to the saved Assessment

			const resultKeys = ['DominantGifts', 'SupportiveGifts', 'OtherGifts'];
			const gifts: TestResults = {};
			for (const key of resultKeys) {
				gifts[key] = {key: key.replace(/([a-z])([A-Z])/g, '$1 $2'), gifts: []};
				for (const guid of result[key]) {
					const gift = assessmentResultData.ResultScores.find(gift => gift.DefinedValueGuid === guid);
					gifts[key].gifts.push(gift);
				}
			}

			const giftsResults = Object.values(gifts);

			const allResults: AllTestResults = {
				testResults: result,
				resultData,
				gifts: giftsResults,
				person: this._targetPerson,
				assessmentResults: assessmentResultData,
				categories: giftsResults.flatMap(g => g.gifts).sort((a,b) => b.TotalScore - a.TotalScore),
				assessment,
				assessmentResponses: this._assessmentResponses,
				version: environment.version
			};
			this.showResults(allResults);
		}

		async showResults(allResults: AllTestResults) {
			
			const modal = await this.modalCtrl.create({
				component: ResultsModalComponent,
				id: 'showResults',
				cssClass: 'fullscreen',
				componentProps: {
					allResults,
					person: allResults.person,
					results: allResults.gifts,
					categories: allResults.categories,
					showCategories: false,
					showTotals: true
				}
			});
			modal.present();

			const { role } = await modal.onWillDismiss();

			if (role === 'submit') {
				this.closeModal(allResults, role);
			}
		}

		btnPrevious_Click() {
				if (this.hfPageNo > 1) {
						const pageNumber = this.hfPageNo - 1;
						this.GetCurrentQuestions();
						this.hfPageNo = pageNumber;
				}
		}

		ShowQuestions() {
				this.pnlInstructions = false;
				this.pnlQuestion = true;
				this.pnlResult = false;

				this.spiritualGiftsService.GetQuestions(this.testTypeOptions.randomizeQuestions).forEach((value, key) => {
						const assessmentResponse = new AssessmentResponse();
						assessmentResponse.Code = key;
						assessmentResponse.Question = value;
						this._assessmentResponses.push(assessmentResponse);
				});

				// If _maxQuestions has not been set yet...
				if (this.QuestionCount === 0 && this._assessmentResponses !== null ) {
						// Set the max number of questions to be no greater than the actual number of questions.
						const numQuestions: number = this.spiritualGiftsService.GetQuestions(this.testTypeOptions.randomizeQuestions).size;
						this.QuestionCount = ( numQuestions > this._assessmentResponses.length ) ? this._assessmentResponses.length : numQuestions;
				}
		}

		GetCurrentQuestions(): AssessmentResponse[] {
				const startIndex = (this.hfPageNo - 1) * this.QuestionCount;
				const endIndex = startIndex + this.QuestionCount;
				this.CurrentQuestions = this._assessmentResponses.slice(startIndex, endIndex);
				return this.CurrentQuestions;
		}
}